/* eslint-disable no-redeclare */
import { z } from 'zod';

export const FirstName = z.string().min(2, {
  message: 'This field is required. Please fill it with valid information.',
});

export type FirstName = z.infer<typeof FirstName>;
